import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../common/services/user.service';
import * as moment from 'moment/moment';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-home-configuration',
  templateUrl: './home-configuration.component.html',
  styleUrls: ['./home-configuration.component.css'],
  providers:[UserService]
})
export class HomeConfigurationComponent implements OnInit {

  constructor(private userService: UserService) { }
  role:number = 3;

  ngOnInit() {
    this.role = JSON.parse(localStorage.getItem('user')).role;  
  }

  dbCopy(){
    this.userService.dbCopy().subscribe((data)=>{
      var blob = new Blob([data._body], {type: "text/plain;charset=utf-8"});
      FileSaver.saveAs(blob, "backup_"+moment().format("DD-MM-YYYY")+".sql");
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/home-configuration/home-configuration.component.ts